
import Button from '@/ui-kit/components/button';
import Logo from '@/components/icons/logo';
import Icon from '@/ui-kit/components/icon';
import Link from '@/ui-kit/components/link';
import Gutter from '@/ui-kit/components/gutter';
import Typography from '@/ui-kit/components/typography';
import SSO from './sso';
import NavLinks from './nav-links';
import FooterLinks from './footer-links';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import { StyleSizeType, StyleColorSchemeType, StylePositionType } from '@/ui-kit/styles/enums';
import { IconType } from '@/ui-kit/components/icon/enums';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import {
  AuthProperty,
  SubmitButtonEventType,
  AuthSlotName,
  AuthErrorMessages,
} from './enums';
import { ERROR_EXCEPTIONS } from './constants';
import AuthProps from './mixins/AuthProps';
import routes from '@/constants/routes';
import IconHintTooltip from '@/components/shared/tooltips/icon-hint-tooltip';
import { IconHintTooltipProperty } from '@/components/shared/tooltips/icon-hint-tooltip/enum';

export default {
  name: 'AuthTemplate',
  components: {
    IconHintTooltip,
    Button,
    Logo,
    Icon,
    Gutter,
    Link,
    Typography,
    SSO,
    NavLinks,
    FooterLinks,
  },
  mixins: [AuthProps],
  data: () => ({
    ButtonFillType,
    StyleColorSchemeType,
    StyleSizeType,
    StylePositionType,
    IconType,
    TypographyType,
    AuthProperty,
    AuthSlotName,
    routes,
    ERROR_EXCEPTIONS,
    AuthErrorMessages,
    IconHintTooltipProperty,
  }),
  computed: {
    isLoginInstead() {
      return this[AuthProperty.ErrorMessage] === ERROR_EXCEPTIONS.UsernameExistsException;
    },
  },
  methods: {
    getErrorMessage(errorName) {
      return AuthErrorMessages[errorName || this[AuthProperty.ErrorMessage]];
    },
    submit(...args) {
      this.$emit(SubmitButtonEventType.Submit, ...args);
    },
    handleLogoClick() {
      this.$router.push(routes.root);
    },
  },
};
